import PropTypes from 'prop-types';
import { useState } from 'react';
import { ROOM_SETTINGS_PAGES } from '../../../../../constants/roomSettings';
import { useRoomSettings } from '../../../../../hooks/useRoomSettings';
import Header from './Header';
import SideBar from './SideBar';
import SecurityPage from './SecurityPage';
import PermissionsPage from './PermissionsPage';
import NotificationsPage from './NotificationsPage';
import pages from './pages';
import './Modal.css';

const Modal = ({
  roomId,
  onClose = () => {},
}) => {
  const [currentPage, setCurrentPage] = useState(pages[0]);
  
  const {
    roomName,
    canConfigure,
    joinRule,
    historyVisibility,
    permissionLevels,
    updateJoinRule,
    updateHistoryVisibility,
    updatePermissionLevel,
  } = useRoomSettings(roomId);

  // Render current page content
  const renderPageContent = () => {
    switch (currentPage) {
    case ROOM_SETTINGS_PAGES.SECURITY:
      return (
        <SecurityPage
          joinRule={joinRule}
          historyVisibility={historyVisibility}
          onJoinRuleChange={updateJoinRule}
          onHistoryVisibilityChange={updateHistoryVisibility}
          canConfigure={canConfigure}
        />
      );
    case ROOM_SETTINGS_PAGES.PERMISSIONS:
      return (
        <PermissionsPage
          permissionLevels={permissionLevels}
          onPermissionChange={updatePermissionLevel}
          canConfigure={canConfigure}
        />
      );
    case ROOM_SETTINGS_PAGES.NOTIFICATIONS:
      return <NotificationsPage />;
    default:
      return null;
    }
  };

  return (
    <div className="room-settings-modal">
      <div className="room-settings-modal-header">
        <Header
          title={roomName}
          onClose={onClose}
        />
      </div>
      <div className="room-settings-modal-body">
        <SideBar
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
        <div className="room-settings-modal-content">
          {renderPageContent()}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  roomId: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

export default Modal;
